import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthProvider";
import API_BASE_URL from "../../config/apiConfig";
import MedicSidebar from "../../components/MedicSidebar";
import faceHappy from "../../assets/images/face-happy.svg";


const MedicDashboard: React.FC = () => {
const { userId } = useAuth(); // userId din AuthProvider

const [formData, setFormData] = useState({
  username: "",
  email: "",
  firstName: "",
  lastName: "",
  phone: "",
  password: "",
});
const [error, setError] = useState<string | null>(null);

const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
  return localStorage.getItem("sidebarCollapsedMedic") === "true";
});

useEffect(() => {
  const fetchMedic = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/users/medic/${userId}`);
      if (!response.ok) throw new Error("Medicul nu a fost găsit.");
      const data = await response.json();
      setFormData({
        username: data.username,
        email: data.email,
        firstName: data.firstname,
        lastName: data.lastname,
        phone: data.phone || "",
        password: "",
      });
    } catch (err: any) {
      setError(err.message);
      console.log(error);
    }
  };

  fetchMedic();
}, [userId]);
  

  return (
    <div className={`dashboard-container ${isCollapsed ? "collapsed" : ""}`}>
      <MedicSidebar onCollapseChange={(collapsed) => setIsCollapsed(collapsed)} />
    <div className="dashboard-content">
      <h1 className="user-welcome"> <img src={faceHappy} alt="user" /> <span className="color-dark">Bine ai venit,</span> {formData.firstName} {formData.lastName}</h1>
      <div className="account-info">
      <h5>Acesta este contul tău personal, unde poți vizualiza și gestiona cu ușurință toate programările la cabinetul medical.</h5> 
      <h5>Ai acces rapid la sesiunile planificate, iar de aici poți adăuga noi programări sau le poți reprograma într-un mod simplu și rapid.</h5> 
      <h5>Pentru a accesa lista completă a programărilor, folosește acest <strong><a href="/medic/appointments">link</a></strong> sau accesează secțiunea <strong>Programări</strong> din meniul din stânga.</h5> 
      <h5>Dacă ai întrebări sau ai nevoie de asistență, echipa noastră îți stă la dispoziție cu drag.</h5>

      </div>
    </div>
    </div>
  );
};

export default MedicDashboard;
